class UiPhone extends HTMLElement {
  async connectedCallback() {
    const countries = JSON.parse(document.querySelector("[data-countries]")?.innerHTML);
    const img = this.querySelector("img");
    const phoneSelect = this.querySelector("[data-phoneselect");
    const phoneValue = this.querySelector("[data-phonevalue");
    const phone = this.querySelector("[data-phone");
    const hiddenValue = this.querySelector("[name=phone]");

    phoneSelect?.addEventListener("change", (e) => {
      const cc = e.target.querySelector("option:checked")?.getAttribute("data-cc");
      const imgSrc = countries.find((x) => x.cc === cc)?.img;
      if (img && imgSrc) img.src = imgSrc;
      phoneValue.innerHTML = e.target.value;
      hiddenValue.value = e.target.value + phone.value;
    });

    phone?.addEventListener("change", (e) => {
      hiddenValue.value = phoneSelect.value + e.target.value;
    });
  }
}

customElements.define("ui-phone", UiPhone);
